export default function ShareCopyIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <g clipPath='url(#clip0_565_1967)'>
        <path
          d='M13.3337 0.833252H1.66699V14.1666H3.33366V2.49992H13.3337V0.833252ZM17.5003 4.16658H5.00033V19.1666H17.5003V4.16658ZM15.8337 17.4999H6.66699V5.83325H15.8337V17.4999Z'
          fill='#0D1333'
        />
      </g>
      <defs>
        <clipPath id='clip0_565_1967'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
